import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const SolarEquipmentReadinessQuery = graphql(`
  query SolarEquipmentReadiness {
    solarEquipmentReadiness {
      hasPreferredPanel
      hasPreferredInverter
    }
  }
`);

/**
 * A design needs a preferred panel to lay on the roof and a preferred inverter
 * to price it. While the answer is unknown the caller is told nothing is
 * missing, so a failed request never blocks an account that is set up.
 */
const useSolarEquipmentReadiness = (options?: { enabled?: boolean }) => {
  const query = useQuery({
    queryKey: applianceKeys.solarEquipmentReadiness(),
    queryFn: () => gqlClient.request(SolarEquipmentReadinessQuery),
    enabled: options?.enabled ?? true,
  });

  const readiness = query.data?.solarEquipmentReadiness;

  return {
    isLoading: query.isLoading,
    missingPanel: readiness ? !readiness.hasPreferredPanel : false,
    missingInverter: readiness ? !readiness.hasPreferredInverter : false,
  };
};

export default useSolarEquipmentReadiness;
